<nz-result *ngIf="showSuccessDiv"
      nzStatus="success"
      [nzTitle]="titleTemplate"
      nzSubTitle="Request number: {{responseModel.Query_Reference_Number}} || Created on : {{responseModel.Created_Date | date:'dd-MMM-yyyy HH:mm:ss'}}"
    >
      <div nz-result-extra>
        <button nz-button nzType="primary" [routerLink]="['/clarification-query/view-query', responseModel.Clarification_Query_Code]">View Query Details</button>
        <button nz-button [routerLink]="'/clarification-query/all_query_request'">View All Queries</button>
      </div>
    </nz-result>
    <ng-template #titleTemplate>
        <div class="ant-result-title ng-star-inserted"> Thank you! <br/> Your Request has been submitted successfully! </div>
      </ng-template>

<div class="create-query-container " nzCompact *ngIf="!showSuccessDiv">    
    <form [formGroup]="createQueryForm" (ngSubmit)="showDeactivateModal()" class="ant-advanced-search-form">
        <div class="form-row bg-dark-blue text-white">
            <span class="span-header">Query Details</span>
          </div>
        <br/>

        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label  [nzSpan]="8" nzRequired>Request Status</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="requestStatus" type="text" class="form-control" formControlName="requestStatus" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Date of Request</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="dateOfRequest" type="text" class="form-control" formControlName="dateOfRequest" readonly />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label  [nzSpan]="8" nzRequired>Subject</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="subject" type="text" class="form-control" formControlName="subject" />
                        <div *ngIf="createQueryForm.get('subject')?.invalid && createQueryForm.get('subject')?.touched" class="text-danger">
                            Subject is required.
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Priority</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <select nz-input id="priority" class="form-control" formControlName="priority">
                            <option *ngFor="let priority of priorityLevels" [value]="priority">
                              {{priorityLevelMapping[priority]}}
                            </option>
                          </select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label  [nzSpan]="8" >CC Emails</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <textarea nz-input id="ccEmails" class="form-control" formControlName="ccEmails"></textarea>
                        <div *ngIf="createQueryForm.get('ccEmails')?.invalid && createQueryForm.get('ccEmails')?.touched" class="text-danger">
                        <div *ngIf="createQueryForm.get('ccEmails')?.errors?.['invalidEmail']">
                            Please enter valid email addresses separated by semicolons.
                        </div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Confidential</nz-form-label>
                    <nz-form-control [nzSpan]="1">
                        <input nz-input class="form-control"
                            id="confidential"
                            type="checkbox"
                            formControlName="confidential"/>
                    </nz-form-control>
                </nz-form-item>
            </div>
            
        </div>
    
        
        <div>
            <div class="form-row bg-dark-blue text-white">
                <span class="span-header">Requestor Details</span>
              </div>
            <br/>
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label  [nzSpan]="8" >Requestor Name</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <ng-container *ngIf="currentUser.IsRFCAdmin; else readonlyRequestorName">
                                <nz-select nz-input
                                  id="requestorName"
                                  formControlName="requestorName"
                                  [nzPlaceHolder]="loadingText" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded"
                                  (ngModelChange)="onRequestorChange($event)">
                                  <nz-option 
                                    *ngFor="let user of partnerUserMaster"
                                    [nzLabel]="user.User_Name"
                                    [nzValue]="user"
                                  ></nz-option>
                                </nz-select>
                              </ng-container>
                              <ng-template #readonlyRequestorName>
                                <input nz-input
                                  id="requestorName"
                                  type="text"
                                  class="form-control"
                                  formControlName="requestorName"
                                  readonly
                                />
                              </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="8" >Requestor Email</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <input nz-input
                                id="requestorEmail"
                                type="text"
                                class="form-control"
                                formControlName="requestorEmail"
                                readonly
                                />
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label  [nzSpan]="8" >Company</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <input nz-input id="company" type="text"class="form-control" formControlName="company" readonly/>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="8" nzRequired >Block</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <!-- Render a textbox if Block_Code is 3 -->
                            <input nz-input *ngIf="requestorDetail?.Block?.Block_Code != 3" nz-inputid="block" type="text" class="form-control"
                                formControlName="block" readonly />

                            <!-- <input nz-input id="block" type="text" class="form-control" formControlName="block" readonly/> -->
                            <nz-select nzRequired                                
                            *ngIf="requestorDetail?.Block?.Block_Code == 3"
                            id="block"
                            class="form-control"
                            [nzStatus]="getNzStatusColor('block')"
                            formControlName="block"
                            [nzPlaceHolder]="loadingText" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded">
                            <nz-option *ngFor="let block of blockMaster" [nzValue]="block.Block_Code" [nzLabel]="block.Block_Name"></nz-option>
                          </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            
        </div>
        <!-- Clarification Request Details Section -->  
        <div>
              <div class="form-row bg-dark-blue text-white">
                <span class="span-header">Clarification Request Details</span>
              </div>
            <br/>
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label  [nzSpan]="8" >Department {{isMasterDataLoaded}}</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <!-- <select id="department" class="form-control" formControlName="department" (change)="onDepartmentChange($any($event.target).value)">
                                <option value="" selected="true">N/A</option>
                                <option *ngFor="let department of departmentMaster" [value]="department.Department_Code" title="{{ department.Department_Name }}">{{ department.Department_Name }}</option>
                              </select> -->
                              <nz-select id="department" class="form-control" formControlName="department" 
                                (ngModelChange)="onDepartmentChange($event)"  
                                [nzPlaceHolder]="loadingText" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded" nzAllowClear>
                                
                                <nz-option *ngFor="let department of departmentMaster" [nzValue]="department.Department_Code" [nzLabel]="department.Department_Name"></nz-option>
                              </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="8" >Sub Department</nz-form-label>
                        <nz-form-control [nzSpan]="16">
                            <!-- <select id="subDepartment" class="form-control" formControlName="subDepartment">
                                <option value="" selected="true">N/A</option>
                                <option *ngFor="let subDepartment of deptSubDeptMaster | orderby: 'Sub_Dept_Name'" [value]="subDepartment.Department_Code" title="{{ subDepartment.Sub_Dept_Name }}">{{ subDepartment.Sub_Dept_Name }}</option>
                              </select> -->

                              <nz-select id="subDepartment"  formControlName="subDepartment" nzPlaceHolder="Choose" nzAllowClear>                               
                                
                                <nz-option *ngFor="let subDepartment of deptSubDeptMaster | orderby: 'Sub_Dept_Name'" 
                                    [nzValue]="subDepartment.Sub_Dept_Code" 
                                    [nzLabel]="subDepartment.Sub_Dept_Name"
                                    nzMode="single"></nz-option>
                              </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label  [nzSpan]="4" >CC</nz-form-label>
                        <nz-form-control [nzSpan]="12">
                            <nz-select
                                id="cc"
                                formControlName="cc"
                                nzMode="multiple"            
                                [nzPlaceHolder]="loadingText" [nzLoading]="!isMasterDataLoaded" [nzDisabled]="!isMasterDataLoaded">
                                <nz-option *ngFor="let item of partnerUserMaster" [nzLabel]="item.User_Name" [nzValue]="item.User_Code"></nz-option>
                                </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>                
            </div>
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="4" nzRequired>Partner Comments</nz-form-label>
                        <nz-form-control [nzSpan]="12">
                            <textarea nz-input id="partnerComments" 
                            class="form-control" 
                            formControlName="partnerComments" 
                            [nzStatus]="getNzStatusColor('partnerComments')"
                            rows="5"></textarea>
                            <div *ngIf="createQueryForm.get('partnerComments')?.invalid && createQueryForm.get('partnerComments')?.touched"
                            class="text-danger">
                                Partner Comments are required.
                            </div>
                        </nz-form-control>
                        <nz-form-control>
                            <button type="button" id="btnFileUpload" nz-button nzType="primary" (click)="openFileUploadModal()" >
                                Add Attachments
                              </button>
                              <br/><label style="margin-left: 10px;"> Attachment count - {{ files.length }}</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>   
            
            <div nz-row [nzGutter]="24">
                <div nz-col [nzSpan]="8"></div>
                <div nz-col [nzSpan]="16">
                    <button type="submit" nz-button nzType="primary" [disabled]="createQueryForm.invalid">Submit</button>
                </div>
            </div>

        </div>
      
    
        
    </form>
  </div>

  